
import { FilterMatchMode } from "primevue/api";
import { computed, defineComponent, onMounted, reactive } from "vue";

import ResearchEquipmentRepositoryAPI from "@/modules/research-equipment/research-equipment-repository-api";
import { useI18n } from "vue-i18n";
import { lazyParamsDefault } from "@/utils/pagination-helper";
import { getCategoryLanguageName } from "@/locales/i18n";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
export default defineComponent({
  setup() {
    const { t } = useI18n();
    const localProperty = getCategoryLanguageName();
    const filters = reactive({
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const { setResearchEquipmentAdmin, loadItem, loadItems } =
      ResearchEquipmentRepositoryAPI();
    const {
      hasBriumAccessRole,
      hasUniversityAccessRole,
      hasFacultyAccessRole,
      getUser,
    } = UserRepositoryAPI();

    const state = reactive({
      localProperty: localProperty,
      dataLoading: true,
      researchEquipmentGroup: [],
      prompt1: false,
      selectedColumns: [
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.organization"
          ),
          field: "researchOrganization",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.researchGroup"
          ),
          field: "researchGroup",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.contactPerson"
          ),
          field: "contactUsers",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.number"
          ),
          field: "number",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.name"
          ),
          field: "name",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.nameEnglish"
          ),
          field: "nameEnglish",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.purchaseEquipmentDateYear"
          ),
          field: "purchaseEquipmentDateYear",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.purchasePrice"
          ),
          field: "purchasePrice",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.fundTypes"
          ),
          field: "equipmentFundingTypes",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.accessTypeDescription"
          ),
          field: "accessTypeDescription",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.accessTypeDescriptionEnglish"
          ),
          field: "accessTypeDescriptionEnglish",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.accessPurposeDescription"
          ),
          field: "accessPurposeDescription",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.accessPurposeDescriptionEnglish"
          ),
          field: "accessPurposeDescriptionEnglish",
        },
        {
          header: t(
            "content.dataManagement.content.equipment.table.header.location"
          ),
          field: "location",
        },

        {
          header: t(
            "content.dataManagement.content.equipment.table.header.detailView"
          ),
          field: "link",
        },
      ] as Array<any>,
      columns: [] as Array<any>,
      selectedDataRow: {} as any,
      lazyParams: lazyParamsDefault,
      keywords: "",
    });

    const onRowSelect = (event: any): void => {
      setResearchEquipmentAdmin(event.data);
    };

    const onPaginatorResearchEquipmentClick = (event: any): void => {
      state.lazyParams = event;
      const researchOrganizationId = getUser.value.researchOrganizationId;
      if (hasBriumAccessRole() || hasUniversityAccessRole()) {
        loadItems(state);
      } else if (hasFacultyAccessRole() && researchOrganizationId) {
        loadItem(state, researchOrganizationId);
      }
    };

    onMounted(() => {
      onPaginatorResearchEquipmentClick(state.lazyParams);
      state.columns = state.selectedColumns;
    });

    const onDisplayColumnUpdateSelection = (value: any) => {
      state.selectedColumns = state.columns.filter((col) =>
        value.includes(col)
      );
    };

    const onSearchKeywordResearchEquipmentClick = (): void => {
      state.lazyParams.page = 0;
      if (state.keywords.length < 3) {
        onPaginatorResearchEquipmentClick(state.lazyParams);
        return;
      }
      state.dataLoading = true;
      const researchOrganizationId = getUser.value.researchOrganizationId;
      if (hasBriumAccessRole() || hasUniversityAccessRole()) {
        loadItems(state);
      } else if (hasFacultyAccessRole() && researchOrganizationId) {
        loadItem(state, researchOrganizationId);
      }
    };

    const truncateText = (text: string): string => {
      return text.substring(0, 15);
    };

    return {
      t,
      filters,
      state: computed(() => state),
      onPaginatorResearchEquipmentClick,
      onDisplayColumnUpdateSelection,
      onSearchKeywordResearchEquipmentClick,
      onRowSelect,
      truncateText,
    };
  },
});
